import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  InternalReportType,
} from "../../../api/tenantInternalReports";
import { downloadBorrowalVsNonBorrowalReportThunk } from "./borrowalVsNonBorrowalReportThunk";
import { downloadFraudByFicCategoryReportThunk } from "./fraudByFicCategoryReportThunk";
import { ExportFormat } from "../../../api/download";

export const downloadInternalReportThunk = createAsyncThunk<
  void,
  { reportType: InternalReportType; format: ExportFormat }
>("internalReports/download", async ({ reportType, format }, { dispatch }) => {
  switch (reportType) {
    case InternalReportType.BORROWAL_VS_NON_BORROWAL:
      await dispatch(downloadBorrowalVsNonBorrowalReportThunk({ format }));
      break;
    case InternalReportType.FRAUD_BY_FIC_CATEGORY:
      await dispatch(downloadFraudByFicCategoryReportThunk({ format }));
      break;
  }
});
